const LABELS = {
  CITY: 'Filtrar por Cidade',
  TIER: 'Filtrar por Tier',
  MODAL_TYPE: 'Filtrar por Veículo',
  PRODUCT: 'Filtrar por Produto',
  STATUS: 'Filtrar por Estado'
};

export default LABELS;
